import { z } from 'zod'

export const schema = z.object({
  success: z.boolean(),
  messageId: z.string().optional(),
  error: z.string().optional(),
})

export type schemaType = z.infer<typeof schema>
